import { render, staticRenderFns } from "./Topic2WeaponWheel.vue?vue&type=template&id=27c224b1&scoped=true"
import script from "./Topic2WeaponWheel.vue?vue&type=script&lang=js"
export * from "./Topic2WeaponWheel.vue?vue&type=script&lang=js"
import style0 from "./Topic2WeaponWheel.vue?vue&type=style&index=0&id=27c224b1&prod&lang=scss&scoped=true"
import style1 from "./Topic2WeaponWheel.vue?vue&type=style&index=1&id=27c224b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c224b1",
  null
  
)

export default component.exports